// Communications Intelligence — feature flag.
//
// Default ON: the new Communications Intelligence is the live Communications
// surface. Explicit opt-out remains for rollback:
//   • REACT_APP_COMMS_INTELLIGENCE in {0,false,no,off}  → forced OFF (build-time)
//   • localStorage 'ci_enabled' in {0,false,no,off}     → forced OFF (per browser)
//   • either in {1,true,yes,on}                          → forced ON
// Otherwise TRUE. Never throws (localStorage access is guarded for SSR/tests).
const _CI_TRUE = new Set(['1', 'true', 'yes', 'on']);
const _CI_FALSE = new Set(['0', 'false', 'no', 'off']);
export function isCommunicationsIntelligenceEnabled() {
  const env = String(process.env.REACT_APP_COMMS_INTELLIGENCE || '').trim().toLowerCase();
  if (_CI_FALSE.has(env)) return false;
  if (_CI_TRUE.has(env)) return true;
  if (typeof window === 'undefined') return true;
  try {
    const ls = String(window.localStorage.getItem('ci_enabled') || '').trim().toLowerCase();
    if (_CI_FALSE.has(ls)) return false;
    if (_CI_TRUE.has(ls)) return true;
  } catch {
    /* ignore */
  }
  return true;
}

export default isCommunicationsIntelligenceEnabled;
